/*
 * -----------------------------------------------------------------------
 *  <copyright file="save-button.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import Button from './button';

const SaveButton = (props: any) => {
    const { id, 'data-testid': testId } = props;

    if (!testId && id) {
        props = {
            ...props,
            'data-testid': id,
        };
    }

    return <Button secondary {...props} />;
};

export default SaveButton;
